// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file auth/v3/auth.proto (package auth.v3, syntax proto3)
/* eslint-disable */

// Package auth.v3 defines the protocol buffer messages and services
// for authentication and authorization throughout the platform.

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AuditMetadata } from "../../common/v3/common_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { User, UserInternal } from "../../users/v3/user_pb";
import { file_users_v3_user } from "../../users/v3/user_pb";
import type { AvailableRealmWithNames, RealmWithNames } from "../../realm/v3/realm_pb";
import { file_realm_v3_realm } from "../../realm/v3/realm_pb";
import type { LanguageRegion } from "../../i18n/v3/language_regions_pb";
import { file_i18n_v3_language_regions } from "../../i18n/v3/language_regions_pb";
import type { Entitlement } from "../../entitlements/v3/entitlements_pb";
import { file_entitlements_v3_entitlements } from "../../entitlements/v3/entitlements_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file auth/v3/auth.proto.
 */
export const file_auth_v3_auth: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v3_common, file_users_v3_user, file_realm_v3_realm, file_i18n_v3_language_regions, file_entitlements_v3_entitlements]);

/**
 * SyncRequest contains the information needed to synchronize a user's
 * authentication state with the system.
 *
 * @generated from message auth.v3.SyncRequest
 */
export type SyncRequest = Message<"auth.v3.SyncRequest"> & {
  /**
   * The variant of the sync workflow to use.
   *
   * @generated from field: auth.v3.SyncWorkflowVariant workflow_variant = 1;
   */
  workflowVariant: SyncWorkflowVariant;

  /**
   * The email address of the user as provided by the authentication system.
   *
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * The display name of the user as provided by the authentication system
   * (if available).
   *
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * Indicates if the email is verified as provided by the
   * authentication system.
   *
   * @generated from field: bool is_email_verified = 4;
   */
  isEmailVerified: boolean;

  /**
   * The URL of the user's profile picture as provided by the
   * authentication system.
   *
   * @generated from field: string photo_url = 5;
   */
  photoUrl: string;

  /**
   * The user agent string of the device (if available)
   *
   * @generated from field: optional string user_agent = 6;
   */
  userAgent?: string;

  /**
   * The user's language preference (e.g., en-US).
   *
   * @generated from field: i18n.v3.LanguageRegion language_region = 7;
   */
  languageRegion: LanguageRegion;

  /**
   * The ID of the device used for authentication.
   * Format: ^device_[a-z0-9]{20}$
   *
   * @generated from field: optional string device_id = 8;
   */
  deviceId?: string;

  /**
   * An optional fingerprint request ID from FingerprintJS Pro used for
   * abuse prevention during new account registration.
   *
   * @generated from field: optional string fingerprint_request_id = 9;
   */
  fingerprintRequestId?: string;

  /**
   * The answers from the sign-up card's two opt-in checkboxes. Absent when
   * no card was shown (sign-in page, extension, older clients); the server
   * then falls back to news subscribed and changelog not.
   *
   * @generated from field: optional auth.v3.MarketingOptIns marketing_opt_ins = 10;
   */
  marketingOptIns?: MarketingOptIns;
};

/**
 * Describes the message auth.v3.SyncRequest.
 * Use `create(SyncRequestSchema)` to create a new message.
 */
export const SyncRequestSchema: GenMessage<SyncRequest> = /*@__PURE__*/
  messageDesc(file_auth_v3_auth, 0);

/**
 * MarketingOptIns carries the marketing preferences collected at sign-up.
 *
 * @generated from message auth.v3.MarketingOptIns
 */
export type MarketingOptIns = Message<"auth.v3.MarketingOptIns"> & {
  /**
   * Whether the user wants news and product updates.
   *
   * @generated from field: bool news = 1;
   */
  news: boolean;

  /**
   * Whether the user wants the changelog.
   *
   * @generated from field: bool changelog = 2;
   */
  changelog: boolean;
};

/**
 * Describes the message auth.v3.MarketingOptIns.
 * Use `create(MarketingOptInsSchema)` to create a new message.
 */
export const MarketingOptInsSchema: GenMessage<MarketingOptIns> = /*@__PURE__*/
  messageDesc(file_auth_v3_auth, 1);

/**
 * SyncResponse contains the result of a user authentication synchronization operation.
 *
 * @generated from message auth.v3.SyncResponse
 */
export type SyncResponse = Message<"auth.v3.SyncResponse"> & {
  /**
   * The authenticated user information.
   *
   * @generated from field: auth.v3.AuthenticatedUser authenticated_user = 1;
   */
  authenticatedUser: AuthenticatedUser;

  /**
   * The reason for token refresh, if applicable.
   *
   * @generated from field: optional auth.v3.TokenRefreshReason token_refresh_reason = 4;
   */
  tokenRefreshReason: TokenRefreshReason;
};

/**
 * Describes the message auth.v3.SyncResponse.
 * Use `create(SyncResponseSchema)` to create a new message.
 */
export const SyncResponseSchema: GenMessage<SyncResponse> = /*@__PURE__*/
  messageDesc(file_auth_v3_auth, 2);

/**
 * The AuthenticatedUser message is used to represent a user who has been
 * authenticated by the system. It includes information about the user
 * and their current realm.
 *
 * @generated from message auth.v3.AuthenticatedUser
 */
export type AuthenticatedUser = Message<"auth.v3.AuthenticatedUser"> & {
  /**
   * User profile information.
   *
   * @generated from field: users.v3.User user = 1;
   */
  user: User;

  /**
   * The current realm the user is operating in. When a user returns, this will
   * be the last realm they were in. When changing realms, this will be the
   * realm the user is switching to.
   *
   * @generated from field: realm.v3.RealmWithNames realm = 2;
   */
  realm: RealmWithNames;

  /**
   * Indicates if changes from external auth providers were detected.
   *
   * @generated from field: bool external_auth_changes_detected = 3;
   */
  externalAuthChangesDetected: boolean;

  /**
   * Indicates if this sync operation created a new user.
   *
   * @generated from field: bool signed_up = 4;
   */
  signedUp: boolean;

  /**
   * Indicates if a guest account has been identified as part of a sign-up.
   *
   * @generated from field: bool is_identified = 5;
   */
  isIdentified: boolean;

  /**
   * Indicates if any pending invites were claimed during sync.
   *
   * @generated from field: bool claimed_invites = 6;
   */
  claimedInvites: boolean;

  /**
   * The list of entitlements associated with the account.
   *
   * @generated from field: repeated entitlements.v3.Entitlement entitlement_list = 7;
   */
  entitlementList: Entitlement[];

  /**
   * A list of realms the user has access to.
   *
   * @generated from field: repeated realm.v3.AvailableRealmWithNames available_realm_list = 8;
   */
  availableRealmList: AvailableRealmWithNames[];
};

/**
 * Describes the message auth.v3.AuthenticatedUser.
 * Use `create(AuthenticatedUserSchema)` to create a new message.
 */
export const AuthenticatedUserSchema: GenMessage<AuthenticatedUser> = /*@__PURE__*/
  messageDesc(file_auth_v3_auth, 3);

/**
 * The AuthenticatedInternalUser message is used to represent a user
 * internally within the system. It includes information that may not be useful
 * to external clients directly such as data that drives entitlements.
 *
 * @generated from message auth.v3.AuthenticatedInternalUser
 */
export type AuthenticatedInternalUser = Message<"auth.v3.AuthenticatedInternalUser"> & {
  /**
   * Internal user information including entitlements and system data.
   *
   * @generated from field: users.v3.UserInternal user = 1;
   */
  user: UserInternal;

  /**
   * The user's display name as provided by a third-party authentication system.
   *
   * @generated from field: string auth_display_name = 4;
   */
  authDisplayName: string;

  /**
   * The user's profile picture URL as provided by a third-party authentication system.
   *
   * @generated from field: string auth_picture_url = 5;
   */
  authPictureUrl: string;

  /**
   * List of external identifiers for this user across authentication systems.
   *
   * @generated from field: repeated auth.v3.ExternalIdentifier external_id_list = 11;
   */
  externalIdList: ExternalIdentifier[];
};

/**
 * Describes the message auth.v3.AuthenticatedInternalUser.
 * Use `create(AuthenticatedInternalUserSchema)` to create a new message.
 */
export const AuthenticatedInternalUserSchema: GenMessage<AuthenticatedInternalUser> = /*@__PURE__*/
  messageDesc(file_auth_v3_auth, 4);

/**
 * The ExternalIdentifier message is used to represent identifiers sourced
 * from external authentication systems
 *
 * @generated from message auth.v3.ExternalIdentifier
 */
export type ExternalIdentifier = Message<"auth.v3.ExternalIdentifier"> & {
  /**
   * A unique identifier for the user in the external system.
   *
   * @generated from field: string external_id = 1;
   */
  externalId: string;

  /**
   * The authentication provider that issued the identifier.
   *
   * @generated from field: auth.v3.AuthenticationProvider provider = 2;
   */
  provider: AuthenticationProvider;

  /**
   * Audit metadata for tracking creation and modification.
   *
   * @generated from field: common.v3.AuditMetadata audit_metadata = 3;
   */
  auditMetadata: AuditMetadata;
};

/**
 * Describes the message auth.v3.ExternalIdentifier.
 * Use `create(ExternalIdentifierSchema)` to create a new message.
 */
export const ExternalIdentifierSchema: GenMessage<ExternalIdentifier> = /*@__PURE__*/
  messageDesc(file_auth_v3_auth, 5);

/**
 * TokenRefreshReason defines the possible reasons for refreshing an authentication token.
 *
 * @generated from enum auth.v3.TokenRefreshReason
 */
export enum TokenRefreshReason {
  /**
   * Default unspecified reason.
   *
   * @generated from enum value: TOKEN_REFRESH_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Token refresh due to new user sign-up.
   *
   * @generated from enum value: TOKEN_REFRESH_REASON_SIGN_UP = 1;
   */
  SIGN_UP = 1,

  /**
   * Token refresh due to stale bearer token.
   *
   * @generated from enum value: TOKEN_REFRESH_REASON_STALE_BEARER_TOKEN = 2;
   */
  STALE_BEARER_TOKEN = 2,

  /**
   * Token refresh due to updated claims.
   *
   * @generated from enum value: TOKEN_REFRESH_REASON_CLAIMS_UPDATED = 3;
   */
  CLAIMS_UPDATED = 3,
}

/**
 * Describes the enum auth.v3.TokenRefreshReason.
 */
export const TokenRefreshReasonSchema: GenEnum<TokenRefreshReason> = /*@__PURE__*/
  enumDesc(file_auth_v3_auth, 0);

/**
 * The SyncWorkflowVariant enum is used to specify the variant of the sync
 * process. It is useful to determine the flow of the sync process and what
 * actions to take based on the variant.
 *
 * @generated from enum auth.v3.SyncWorkflowVariant
 */
export enum SyncWorkflowVariant {
  /**
   * Default unspecified variant.
   *
   * @generated from enum value: SYNC_WORKFLOW_VARIANT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Default workflow variant for general use.
   *
   * @generated from enum value: SYNC_WORKFLOW_VARIANT_DEFAULT = 1;
   */
  DEFAULT = 1,

  /**
   * Workflow variant optimized for web application usage.
   *
   * @generated from enum value: SYNC_WORKFLOW_VARIANT_WEB_APP = 2;
   */
  WEB_APP = 2,
}

/**
 * Describes the enum auth.v3.SyncWorkflowVariant.
 */
export const SyncWorkflowVariantSchema: GenEnum<SyncWorkflowVariant> = /*@__PURE__*/
  enumDesc(file_auth_v3_auth, 1);

/**
 * AuthenticationProvider defines the supported external authentication systems.
 *
 * @generated from enum auth.v3.AuthenticationProvider
 */
export enum AuthenticationProvider {
  /**
   * Default unspecified provider.
   *
   * @generated from enum value: AUTHENTICATION_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Firebase authentication provider (Google authentication).
   *
   * @generated from enum value: AUTHENTICATION_PROVIDER_FIREBASE = 1;
   */
  FIREBASE = 1,
}

/**
 * Describes the enum auth.v3.AuthenticationProvider.
 */
export const AuthenticationProviderSchema: GenEnum<AuthenticationProvider> = /*@__PURE__*/
  enumDesc(file_auth_v3_auth, 2);

/**
 * AuthService provides authentication-related operations for the platform.
 *
 * @generated from service auth.v3.AuthService
 */
export const AuthService: GenService<{
  /**
   * Sync synchronizes user authentication information with the system.
   * This handles various authentication workflows including sign-up and token refresh.
   *
   * @generated from rpc auth.v3.AuthService.Sync
   */
  sync: {
    methodKind: "unary";
    input: typeof SyncRequestSchema;
    output: typeof SyncResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_auth_v3_auth, 0);

